import { onBeforeUnmount, onMounted, ref } from 'vue';

/**
 * Mobile-first viewport state of the support portal: the list/detail split is
 * a single column below 768px, where the detail is promoted to a full screen
 * overlay instead of a side panel.
 */
export function useSupportTicketViewport() {
  const isMobile = ref(false);
  const mobileDetailOpen = ref(false);
  let mediaQuery = null;

  const syncMobileState = event => {
    isMobile.value = Boolean(event.matches);
    if (!isMobile.value) mobileDetailOpen.value = false;
  };

  onMounted(() => {
    if (typeof window !== 'undefined' && window.matchMedia) {
      mediaQuery = window.matchMedia('(max-width: 767px)');
      syncMobileState(mediaQuery);
      if (mediaQuery.addEventListener) {
        mediaQuery.addEventListener('change', syncMobileState);
      } else if (mediaQuery.addListener) {
        mediaQuery.addListener(syncMobileState);
      }
    }
  });

  onBeforeUnmount(() => {
    if (!mediaQuery) return;
    if (mediaQuery.removeEventListener) {
      mediaQuery.removeEventListener('change', syncMobileState);
    } else if (mediaQuery.removeListener) {
      mediaQuery.removeListener(syncMobileState);
    }
  });

  return { isMobile, mobileDetailOpen };
}
